<template>
  <AGAutocomplete
    v-model="localValue"
    :filter-keys="['title', 'value', 'raw.subtitle']"
    :disabled="disabled"
    :loading="loadingUserEstablishments"
    :has-select-all="hasSelectAll"
    :has-select-group="hasSelectGroup"
    :items="autocompleteItems"
    :label="label"
    :limit="limit"
    :multiple="multiple"
    :return-object="returnObject"
  />
</template>

<script>
import AGAutocomplete from '@/components/common/AGAutocomplete.vue';
import { useStoreAuth } from '@/stores/StoreAuth';
import { mapState } from 'pinia';

export default {
  components: {
    AGAutocomplete,
  },

  emits: ['change', 'update:modelValue', 'hasCompany'],

  props: {
    label: {
      type: String,
      required: true,
    },

    modelValue: {
      type: [Boolean, String, Number, Array, Object],
      default: null,
    },

    returnObject: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hasSelectAll: {
      type: Boolean,
      default: false,
    },

    hasSelectGroup: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    limit: {
      type: Number,
      default: -1,
    },

    rootCnpjs: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(useStoreAuth, {
      loadingUserEstablishments: (store) => store.loadingUserEstablishments,
      parsedRootCnpjs: (store) => store.parsedRootCnpjs,
      parsedEstablishments: (store) => store.parsedEstablishments,
    }),
    localValue: {
      get() {
        return this.modelValue;
      },

      set(val) {
        this.$emit('update:modelValue', val);
        this.$emit('change', val);
      },
    },
    autocompleteItems() {
      return this.rootCnpjs ? this.parsedRootCnpjs : this.parsedEstablishments;
    },
  },
};
</script>
